import { INameDisplayable, instanceOfINameDisplayable } from "./INameDisplayable";

export interface ICheckable extends INameDisplayable {
  isChecked: boolean;
}

export function instanceOfICheckable(instance: any): instance is ICheckable {
  return instance
      && (instance.isChecked !== undefined)
      && instanceOfINameDisplayable(instance);
}
